import { Instagram, Mail } from "lucide-react";
import { CONTACT_EMAIL, IMG, INSTAGRAM_HANDLE, INSTAGRAM_URL, NAV_ITEMS, SITE_URL, scrollToId } from "../content";

const Footer = () => {
  const go = (id) => (e) => {
    e.preventDefault();
    scrollToId(id);
  };

  return (
    <footer className="footer" data-testid="site-footer">
      <div className="footer-top">
        <img src={IMG.logo} alt="Mindful Athlete" className="footer-logo" data-testid="footer-logo" />
        <p className="footer-tagline" data-testid="footer-tagline">Mindset • Movement • Recovery • Resilience</p>
      </div>
      <nav className="footer-nav" aria-label="Footer">
        {NAV_ITEMS.map(([label, id]) => (
          <a key={id} href={`#${id}`} onClick={go(id)} data-testid={`footer-${id}-link`}>
            {label}
          </a>
        ))}
      </nav>
      <div className="footer-contact">
        <a href={INSTAGRAM_URL} target="_blank" rel="noreferrer" data-testid="footer-instagram-link">
          <Instagram size={15} /> {INSTAGRAM_HANDLE}
        </a>
        <a href={`mailto:${CONTACT_EMAIL}`} data-testid="footer-email-link">
          <Mail size={15} /> {CONTACT_EMAIL}
        </a>
        <span data-testid="footer-website">{SITE_URL}</span>
      </div>
      <div className="footer-legal">
        <a href="#contact" onClick={go("contact")} data-testid="footer-privacy-link">Privacy Policy</a>
        <a href="#contact" onClick={go("contact")} data-testid="footer-terms-link">Terms</a>
        <span className="footer-copy">© 2026 Mindful Athlete</span>
      </div>
    </footer>
  );
};

export default Footer;
